import { ReactElement, useEffect } from 'react';
import styles from './AppContent.module.less';
import AppRoute from '../../AppRoute';
import { Alert } from 'antd';
import { Link, useParams } from 'react-router-dom';
import { notification } from 'antd';
import CcxIconCloseCircleTwoTone from '../ccx/icons/CcxIconCloseCircleTwoTone';
import AppContentTemplate from './AppContentTemplate';
import { useAppDispatch, useAppSelector } from '../../redux/hooks';
import { updateProfile } from '../../slices/user.slice';
import { getDeploymentOptions } from '../../slices/deploymentOptions.slice';

interface UrlProps {
    projectUuid: string;
}

function AppContent(): ReactElement {
    const { projectUuid } = useParams<UrlProps>();

    const { user } = useAppSelector((state) => state.user);

    useEffect(() => {
        if (
            user?.isAdmin &&
            window.location.href.split('/').at(-1) !== 'admin'
        ) {
            window.location.href = '/admin';
        }
    }, [user]);

    const dispatch = useAppDispatch();

    useEffect(() => {
        dispatch(getDeploymentOptions());
    }, []);

    const onAlertClose = async () => {
        try {
            dispatch(updateProfile());
        } catch (e) {
            notification.open({
                message: 'New User',
                description: `There was an error . ${e}`,
                icon: <CcxIconCloseCircleTwoTone twoToneColor="#eb2f96" />,
            });
        }
    };

    return (
        <AppContentTemplate>
            <AppRoute />
        </AppContentTemplate>
    );
}

export default AppContent;
